import { render, staticRenderFns } from "./tips2.vue?vue&type=template&id=3ca7dda8&scoped=true"
import script from "./tips2.vue?vue&type=script&lang=js"
export * from "./tips2.vue?vue&type=script&lang=js"
import style0 from "./tips2.vue?vue&type=style&index=0&id=3ca7dda8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca7dda8",
  null
  
)

export default component.exports